export function shouldShowCoppa({
  parent,
  learners,
  activity
}: {
  parent: { consented_to_coppa_notice_at?: Date };
  learners: { age?: number }[];
  activity?: { price_cents: number | null; isClub: boolean };
}): boolean {
  // If is a free club enrollment, always require Coppa consent
  if (
    activity &&
    activity.isClub &&
    activity.price_cents === 0 &&
    parent &&
    !parent.consented_to_coppa_notice_at
  ) {
    return true;
  }

  //Show the coppa modal if:
  //* There is an enrolling parent (not a charter admin enrolling the learner)
  //* The parent hasn't consented to coppa yet
  //* The parent is enrolling a learner under 13
  return (
    parent &&
    !parent.consented_to_coppa_notice_at &&
    // @ts-ignore TS(2532): Object is possibly 'undefined'.
    learners.some(learner => learner?.age < 13)
  );
}
